import { render, staticRenderFns } from "./EditSinisterPackages.vue?vue&type=template&id=64d070ae&scoped=true"
import script from "./EditSinisterPackages.vue?vue&type=script&lang=js"
export * from "./EditSinisterPackages.vue?vue&type=script&lang=js"
import style0 from "./EditSinisterPackages.vue?vue&type=style&index=0&id=64d070ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d070ae",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/extranet/EditSinisterPackages.vue
// module id = 2082
// module chunks = 31